import { useMemo, useState } from 'react'
import { FilterProps, useAsyncDebounce } from 'react-table'
import { Slider, TextField } from '@mui/material'
import { EnhancedHeader } from '../../../../types'

interface Props<D extends object> extends FilterProps<D> {
  column: EnhancedHeader<D>
  columns: EnhancedHeader<D>[]
}

export default function RangeFilter<D extends object>({
  column: { id, filterValue, preFilteredRows, setFilter },
}: Props<D>) {
  const [min, max] = useMemo(() => {
    let min = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
    let max = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
    preFilteredRows.forEach((row) => {
      min = Math.min(row.values[id], min)
      max = Math.max(row.values[id], max)
    })
    return [min, max]
  }, [id, preFilteredRows])
  const [value, setValue] = useState(filterValue || [min, max])

  const onChange = useAsyncDebounce((value) => {
    setFilter(value)
  }, 300)

  return (
    <div>
      <TextField
        label="Min"
        fullWidth
        size="small"
        type="number"
        value={value[0]}
        onChange={(evt) => {
          const parsedValue = parseInt(evt.target.value)
          const newMin = !Number.isNaN(parsedValue) ? parsedValue : min
          const newValue = newMin < value[1] ? [newMin, value[1]] : [value[1], newMin]
          setValue(newValue)
          onChange(newValue)
        }}
      />
      <Slider
        size="small"
        min={min}
        max={max}
        value={value}
        onChange={(_evt, newValue) => {
          setValue(newValue as number[])
          onChange(newValue)
        }}
      />
      <TextField
        label="Max"
        fullWidth
        size="small"
        type="number"
        value={value[1]}
        onChange={(evt) => {
          const parsedValue = parseInt(evt.target.value)
          const newMax = !Number.isNaN(parsedValue) ? parsedValue : max
          const newValue = newMax > value[0] ? [value[0], newMax] : [newMax, value[0]]
          setValue(newValue)
          onChange(newValue)
        }}
      />
    </div>
  )
}
